export default "__VITE_ASSET__CWYNU1Pe__"